import request from '@/utils/request'
import { ConstConfig } from '@/constants'

export function getWeChatSignature(params) { // GetWechatMppSign.json
  return request({
    url: process.env.VUE_APP_CB_API + ConstConfig.apiPath + '/GetWechatMpSign.json',
    method: 'get',
    params
  })
}

